// Debug control - use i.e. DEBUG && console.log("whatever") and set below const true
const DEBUG = process.env.REACT_APP_DEBUG == 'enabled';

const amplifyconfiguration = {
  "Auth": {
    "Cognito": {
      "userPoolId": process.env.REACT_APP_USER_POOL_ID,
      "userPoolClientId": process.env.REACT_APP_USER_POOL_WEB_CLIENT_ID,
      "identityPoolId": "",
      "signUpVerificationMethod": "code",
      "loginWith": {
        "email": true,
        "phone": false,
        "username": false,
        "oauth": {
          "domain": process.env.REACT_APP_COGNITO_DOMAIN,
          "scopes": ["email", "profile", "openid", "aws.cognito.signin.user.admin"],
          "redirectSignIn": [
            window.location.origin + "/",
            "https://dev.d3p84rqgooztc6.amplifyapp.com/"
          ],
          "redirectSignOut": [
            window.location.origin + "/",
            "https://dev.d3p84rqgooztc6.amplifyapp.com/"
          ],
          "responseType": "code"
        }
      },
      "mfa": {
        "status": "optional",
        "totpEnabled": true,
        "smsEnabled": false,
        "emailEnabled": true
      }
    }
  }
};

// Log configuration for debugging
DEBUG && console.log('Amplify configuration:', amplifyconfiguration);
DEBUG && console.log('Current origin:', window.location.origin);

export default amplifyconfiguration;